import Ext from "Ext";
import SimpleUsersAndGroupsSelectionHelper from "./simple_users_and_groups_selection_helper";
import messageResource from  "../../../messageResource";
import GroupType from "../../../enums/GroupType";
import { UserGroupValidatorStrategy, TimeZoneGroupValidatorStrategy } from "../../../util/GroupValidatorStrategy";
import { userComparator } from "../../../usersSelector/user_group_selector_util";
import { truncateStringByLength, escapeHtmlSymbols, concatStr } from "../../../atUtils";

/**
 * Is used to generate string representation for item list have been passed to <code>getDescription</code> method
 *
 * @constructor
 * AT.SelectionHelper
 */
const ComplicateUsersAndGroupsSelectionHelper = Ext.extend(SimpleUsersAndGroupsSelectionHelper, {

    /**
     * @see AT.AccessRightsUsersSelectorPanel.accessRight (required)
     */
    accessRight: null,
    userTemplate: '<span class="{0}">{1}</span>{2}',
    defaultUserCls: "selected-user",
    invalidUserCls: "selected-user invalid-user",
    maxLength: 50,
    itemNounSingularKey: "mail_notifications.users_selector.label.singular",
    itemNounPluralKey: "mail_notifications.users_selector.label.plural",
    noEmailMessageKey: "mail_notifications.users_selector.label.without_email",

    itemNoEmailMessageKey: "mail_notifications.users_selector.tooltip.without_email",

    isNeededInformationAboutDisabledUsers: false,

    checkEmail: false,

    getDescription: function(selection, dropdownButtonId) {
        var result = "";
        var resultText = "";
        var suffix = "";
        var groups = selection.getFirstLevel();
        var users = selection.getSecondLevel();
        var groupType = selection.groupType;
        if ((groups.length == 0) && (users.length == 0)) {
            return this.getMessage(this.pleaseSelectMessageKey);
        }
        else if (groups.length == 0){
            var itemClass,
                itemSuffix,
                itemText,
                preparedItem,
                preparedItems = new Array(),
                textLength = 0,
                returnTextLength = this.maxLength;

            users.sort(userComparator);
            for(var i = 0; i < users.length; i++) {
                preparedItem = {};
                itemClass = this.defaultUserCls;
                if( this.checkEmail && (!users[i].isActive() || !users[i].hasEmail() ||
                                         (this.accessRight && !this.accessRight.isGranted( users[i].accessRight )))) {
                    itemClass = this.invalidUserCls;
                }
                itemSuffix = (i == users.length - 1) ? "" : "; ";
                itemText = users[i].formatNameLFM();

                preparedItem.text = itemText;
                preparedItem.suffix = itemSuffix;
                preparedItem.cls = itemClass;
                preparedItems.push(preparedItem);

                textLength += itemText.length;
            }
            if (textLength > this.maxLength) {
                var itemNounKey = preparedItems.length > 1 ? this.itemNounPluralKey : this.itemNounSingularKey;
                suffix = "(" + preparedItems.length + " " + this.getMessage(itemNounKey) + ")";

                returnTextLength -= suffix.length;
            }

            for( i = 0; i < preparedItems.length; i++)
            {
                var isGreaterMaxLength = false;
                if( returnTextLength < preparedItems[i].text.length )
                {
                    if (resultText.length == 0)
                    {
                        preparedItems[i].text = truncateStringByLength(preparedItems[i].text, returnTextLength, false);
                        preparedItems[i].suffix = "";
                    }
                    isGreaterMaxLength = true;
                }
                result += messageResource.applyParamsSubstitutions( this.userTemplate,
                                       [ preparedItems[i].cls,
                                         escapeHtmlSymbols(preparedItems[i].text),
                                         preparedItems[i].suffix],
                                       0 );
                if(isGreaterMaxLength)
                    break;
                returnTextLength -= preparedItems[i].text.length;
            }
            return result + ( suffix ? " " + suffix : "" );
        } else if ((users.length == 0) && (groups.length == 1)){
            var validatorGroupStrategy = (groupType == GroupType.TIME_ZONE_GROUP) ? new TimeZoneGroupValidatorStrategy() : new UserGroupValidatorStrategy();
            return this.getSingleItemText(groups[0], true, validatorGroupStrategy);
        } else {
            return this.getShortDescriptionForUsersAndGroups(groups, users, dropdownButtonId, groupType);
        }
    },

    getListDescriptionItemStatus : function ( user ) {
        var hasAccessRight = this.accessRight && this.accessRight.isGranted( user.accessRight );
        var hasEmail = !this.checkEmail || user.hasEmail();
        var result = "";

        if ( this.accessRight && !hasAccessRight && !hasEmail )
            result = this.accessRight.getUserNoEmailAndRightsMessage();
        else if( this.accessRight && !hasAccessRight )
            result = this.accessRight.getUserNoRightsMessage();
        else if ( !hasEmail )
            result = this.getMessage(this.itemNoEmailMessageKey);
        return concatStr(ComplicateUsersAndGroupsSelectionHelper.superclass.getListDescriptionItemStatus.call(this, user), result, " ");
    }


});

export default ComplicateUsersAndGroupsSelectionHelper;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/selectionHelpers/complicate_users_and_groups_selection_helper.js